import styled from 'styled-components';

export const BoostModalWapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
export const LogoWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 120px;
  height: 120px;
  margin-top: 0px;
  margin-bottom: 15px;
  img {
    width: 100%;
    height: 100%;
  }
`;
export const TextWrapper = styled.div`
  text-align: center;
  small {
    font-size: 12px;
  }
`;
